import { InputText } from "primereact/inputtext";
import localeText from "../../../locale";

const NameFields = ({ fullName, setFullName, loading }) => {
  return (
    <div className="w-full">
      <label className="font-semibold text-sm" htmlFor="fullName" style={{ color: "#0D0D0E" }}>
        {localeText("fullName")}
      </label>
      <div className="mt-2">
        <InputText
          name="fullName"
          type="text"
          value={fullName}
          onChange={(e) => setFullName(e.target.value)}
          className="w-full p-3"
          placeholder={localeText("fullName")}
          disabled={loading}
        />
      </div>
    </div>
  );
};

export default NameFields;

